import { render, staticRenderFns } from "./RelatedFigures.vue?vue&type=template&id=c24863ea&scoped=true"
import script from "./RelatedFigures.vue?vue&type=script&lang=js"
export * from "./RelatedFigures.vue?vue&type=script&lang=js"
import style0 from "./RelatedFigures.vue?vue&type=style&index=0&id=c24863ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24863ea",
  null
  
)

export default component.exports